import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import 'moment/locale/it';
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import ReduxLanguage from '../../components/ReduxLanguage';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as ProductInfoActions from '../../redux/productinfo/productinfo.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface IIseoTrainingMaterialsProps extends WithStyles<typeof styles> {
  language: string;
}

export type ComponentProps = IIseoTrainingMaterialsProps & IReduxProps;

export interface IIseoTrainingMaterialsState {
}

class IseoTrainingMaterialsPage extends React.Component<ComponentProps, IIseoTrainingMaterialsState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
    };
  }

  async componentDidMount() {
    const { dispatch, language } = this.props;
    try {
      await dispatch<any>(ProductInfoActions.fetchIseoTrainingMaterials(language));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_OPEN_ISEO_TRAINING_MATERIALS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.openIseoTrainingMaterialsError',
        }
      }));
    }
  }

  render() {
    const { classes, iseoTrainingMaterials } = this.props;
    return (
      <div className={classes.container}>
        <div style={{ backgroundColor: 'white' }}>
          {iseoTrainingMaterials && iseoTrainingMaterials.length > 0 ? (
            <div style={{ padding: 25, paddingLeft: 20, paddingTop: 10, marginBottom: 0, backgroundColor: '#f1f1f1' }}>
              <div
                className="productInfoContentContainer"
                style={{ maxHeight: 'unset !important', padding: 25, paddingLeft: 20, paddingTop: 10, marginTop: 10, marginBottom: 0, backgroundColor: 'white', borderRadius: 10 }}
                dangerouslySetInnerHTML={{ __html: iseoTrainingMaterials[0].content.rendered }}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    iseoTrainingMaterials: state.productInfo.iseoTrainingMaterials.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(IseoTrainingMaterialsPage as any));
